import { AsyncPipe } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { PlantModelParameterService } from '@app/services/plant-model-parameter.service';
import { DeviceBaseComponent } from '@app/shared/device-base.component';
import { PlantModelParameterFormComponent } from '@app/shared/plant-model-parameter-form/plant-model-parameter-form.component';
import { Device } from '@app/store/device.model';
import { PlantModelParameter } from '@app/store/plant-model-parameter.model';

@Component({
  selector: 'app-plant-model',
  templateUrl: './plant-model.component.html',
  imports: [PlantModelParameterFormComponent, AsyncPipe],
})
export class PlantModelComponent extends DeviceBaseComponent {
  private plantModelParameterService = inject(PlantModelParameterService);

  parameters$: Observable<PlantModelParameter[]>;
  filterActive$ = new BehaviorSubject<boolean>(false);

  @Input()
  set filterActive(bool: boolean) {
    this.filterActive$.next(bool);
  }

  onDeviceChange(device: Device) {
    this.parameters$ = this.filterActive$.pipe(
      switchMap((filterActive) =>
        this.componentMode === 'setup'
          ? this.plantModelParameterService.selectDevicePlantModelParametersForSetup(device, filterActive)
          : this.plantModelParameterService.selectDevicePlantModelParameters(device),
      ),
    );
  }
}
